/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { DataPageOfReportCategory } from '../models/data-page-of-report-category';
import { DataPageOfReportCategoryDto } from '../models/data-page-of-report-category-dto';
import { ReportCategory } from '../models/report-category';
import { reportCategoryAddReportCategory } from '../fn/report-category/report-category-add-report-category';
import { ReportCategoryAddReportCategory$Params } from '../fn/report-category/report-category-add-report-category';
import { reportCategoryAddReportCategoryWithRoles } from '../fn/report-category/report-category-add-report-category-with-roles';
import { ReportCategoryAddReportCategoryWithRoles$Params } from '../fn/report-category/report-category-add-report-category-with-roles';
import { reportCategoryDelete } from '../fn/report-category/report-category-delete';
import { ReportCategoryDelete$Params } from '../fn/report-category/report-category-delete';
import { reportCategoryDelete2 } from '../fn/report-category/report-category-delete-2';
import { ReportCategoryDelete2$Params } from '../fn/report-category/report-category-delete-2';
import { ReportCategoryDto } from '../models/report-category-dto';
import { reportCategoryGet } from '../fn/report-category/report-category-get';
import { ReportCategoryGet$Params } from '../fn/report-category/report-category-get';
import { reportCategoryGetAll } from '../fn/report-category/report-category-get-all';
import { ReportCategoryGetAll$Params } from '../fn/report-category/report-category-get-all';
import { reportCategoryGetByRoleId } from '../fn/report-category/report-category-get-by-role-id';
import { ReportCategoryGetByRoleId$Params } from '../fn/report-category/report-category-get-by-role-id';
import { reportCategoryPost } from '../fn/report-category/report-category-post';
import { ReportCategoryPost$Params } from '../fn/report-category/report-category-post';
import { reportCategoryPut } from '../fn/report-category/report-category-put';
import { ReportCategoryPut$Params } from '../fn/report-category/report-category-put';
import { reportCategoryUpdate } from '../fn/report-category/report-category-update';
import { ReportCategoryUpdate$Params } from '../fn/report-category/report-category-update';

@Injectable({ providedIn: 'root' })
export class ReportCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reportCategoryGet()` */
  static readonly ReportCategoryGetPath = '/api/ReportCategory/reportcategories/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGet$Response(params?: ReportCategoryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportCategory>> {
    return reportCategoryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGet(params?: ReportCategoryGet$Params, context?: HttpContext): Observable<DataPageOfReportCategory> {
    return this.reportCategoryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfReportCategory>): DataPageOfReportCategory => r.body)
    );
  }

  /** Path part for operation `reportCategoryGetByRoleId()` */
  static readonly ReportCategoryGetByRoleIdPath = '/api/ReportCategory/reportcategories/listByRoleID';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryGetByRoleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGetByRoleId$Response(params?: ReportCategoryGetByRoleId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportCategoryDto>>> {
    return reportCategoryGetByRoleId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryGetByRoleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGetByRoleId(params?: ReportCategoryGetByRoleId$Params, context?: HttpContext): Observable<Array<ReportCategoryDto>> {
    return this.reportCategoryGetByRoleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReportCategoryDto>>): Array<ReportCategoryDto> => r.body)
    );
  }

  /** Path part for operation `reportCategoryAddReportCategory()` */
  static readonly ReportCategoryAddReportCategoryPath = '/api/ReportCategory/reportcategories/saving';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryAddReportCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryAddReportCategory$Response(params: ReportCategoryAddReportCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportCategoryAddReportCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryAddReportCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryAddReportCategory(params: ReportCategoryAddReportCategory$Params, context?: HttpContext): Observable<Blob> {
    return this.reportCategoryAddReportCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportCategoryGetAll()` */
  static readonly ReportCategoryGetAllPath = '/api/ReportCategory/reportcategories/getalllist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGetAll$Response(params?: ReportCategoryGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportCategoryDto>> {
    return reportCategoryGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryGetAll(params?: ReportCategoryGetAll$Params, context?: HttpContext): Observable<DataPageOfReportCategoryDto> {
    return this.reportCategoryGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfReportCategoryDto>): DataPageOfReportCategoryDto => r.body)
    );
  }

  /** Path part for operation `reportCategoryAddReportCategoryWithRoles()` */
  static readonly ReportCategoryAddReportCategoryWithRolesPath = '/api/ReportCategory/reportcategories/adding';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryAddReportCategoryWithRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryAddReportCategoryWithRoles$Response(params: ReportCategoryAddReportCategoryWithRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportCategoryAddReportCategoryWithRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryAddReportCategoryWithRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryAddReportCategoryWithRoles(params: ReportCategoryAddReportCategoryWithRoles$Params, context?: HttpContext): Observable<Blob> {
    return this.reportCategoryAddReportCategoryWithRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportCategoryUpdate()` */
  static readonly ReportCategoryUpdatePath = '/api/ReportCategory/update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryUpdate$Response(params: ReportCategoryUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportCategoryUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryUpdate(params: ReportCategoryUpdate$Params, context?: HttpContext): Observable<Blob> {
    return this.reportCategoryUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportCategoryPost()` */
  static readonly ReportCategoryPostPath = '/api/ReportCategory/reportcategories/insert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryPost$Response(params: ReportCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return reportCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryPost(params: ReportCategoryPost$Params, context?: HttpContext): Observable<Blob> {
    return this.reportCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `reportCategoryPut()` */
  static readonly ReportCategoryPutPath = '/api/ReportCategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryPut$Response(params: ReportCategoryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCategory>> {
    return reportCategoryPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportCategoryPut(params: ReportCategoryPut$Params, context?: HttpContext): Observable<ReportCategory> {
    return this.reportCategoryPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReportCategory>): ReportCategory => r.body)
    );
  }

  /** Path part for operation `reportCategoryDelete()` */
  static readonly ReportCategoryDeletePath = '/api/ReportCategory/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryDelete$Response(params: ReportCategoryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return reportCategoryDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryDelete(params: ReportCategoryDelete$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.reportCategoryDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

  /** Path part for operation `reportCategoryDelete2()` */
  static readonly ReportCategoryDelete2Path = '/api/ReportCategory/reportcategories/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportCategoryDelete2()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryDelete2$Response(params?: ReportCategoryDelete2$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return reportCategoryDelete2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportCategoryDelete2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reportCategoryDelete2(params?: ReportCategoryDelete2$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.reportCategoryDelete2$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

}
